(function () {
  "use strict";
  var doc = document;
  var STATE = "data-xg-state";
  var LOCK = "data-xg-scroll-lock";
  var BOUND = "data-xg-drawer-bound";
  var returnTo = {};
  function reduced() {
    return (
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }
  function drawer(id) {
    var el = id && doc.getElementById(id);
    return el && el.classList.contains("xg-drawer") ? el : null;
  }
  function syncTriggers(id, expanded) {
    var nodes = doc.querySelectorAll('[data-xg-drawer-open="' + id + '"]');
    for (var i = 0; i < nodes.length; i += 1) {
      if (nodes[i].hasAttribute("aria-expanded")) {
        nodes[i].setAttribute("aria-expanded", expanded ? "true" : "false");
      }
    }
  }
  function anyOpen() {
    return doc.querySelector(".xg-drawer[open]") !== null;
  }
  function open(id, trigger) {
    var dlg = drawer(id);
    if (!dlg || dlg.open) return;
    returnTo[id] = trigger || doc.activeElement;
    if (!dlg.hasAttribute(BOUND)) {
      dlg.setAttribute(BOUND, "");
      dlg.addEventListener("cancel", function (event) {
        event.preventDefault();
        close(dlg.id);
      });
    }
    if (typeof dlg.showModal === "function") dlg.showModal();
    else dlg.setAttribute("open", "");
    doc.documentElement.setAttribute(LOCK, "");
    syncTriggers(id, true);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (dlg.open) dlg.setAttribute(STATE, "open");
      });
    });
    dlg.dispatchEvent(new CustomEvent("xg:drawer:open", { bubbles: true }));
  }
  function finish(dlg) {
    if (!dlg.open) return;
    var id = dlg.id;
    dlg.close();
    if (!anyOpen()) doc.documentElement.removeAttribute(LOCK);
    syncTriggers(id, false);
    var back = returnTo[id];
    returnTo[id] = null;
    if (back && doc.contains(back) && typeof back.focus === "function") {
      back.focus({ preventScroll: true });
    }
    dlg.dispatchEvent(new CustomEvent("xg:drawer:close", { bubbles: true }));
  }
  function close(id) {
    var dlg = drawer(id);
    if (!dlg || !dlg.open) return;
    dlg.removeAttribute(STATE);
    var panel = dlg.querySelector(".xg-drawer__panel");
    if (reduced() || !panel) {
      finish(dlg);
      return;
    }
    var guard = setTimeout(function () {
      panel.removeEventListener("transitionend", onEnd);
      finish(dlg);
    }, 800);
    function onEnd(event) {
      if (event.target !== panel || event.propertyName !== "transform") return;
      clearTimeout(guard);
      panel.removeEventListener("transitionend", onEnd);
      finish(dlg);
    }
    panel.addEventListener("transitionend", onEnd);
  }
  doc.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var trigger = target.closest("[data-xg-drawer-open]");
    if (trigger) {
      var id = trigger.getAttribute("data-xg-drawer-open");
      if (drawer(id)) {
        event.preventDefault();
        open(id, trigger);
      }
      return;
    }
    var closer = target.closest("[data-xg-drawer-close]");
    if (closer) {
      var host = closer.closest(".xg-drawer");
      if (host) close(host.id);
      return;
    }
    if (target.matches && target.matches(".xg-drawer[open]")) close(target.id);
  });
  doc.addEventListener("keydown", function (event) {
    if (event.key !== "Escape" || event.defaultPrevented) return;
    var host = event.target && event.target.closest
      ? event.target.closest(".xg-drawer[open]")
      : null;
    var dlg = host || doc.querySelector(".xg-drawer[open]");
    if (!dlg) return;
    event.preventDefault();
    close(dlg.id);
  });
  doc.addEventListener("shopify:section:unload", function () {
    if (!anyOpen()) doc.documentElement.removeAttribute(LOCK);
  });
  window.XG = window.XG || {};
  window.XG.drawer = { open: open, close: close };
})();
